import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

import PageLayout from '../_partials/PageLayout';
import { Spin } from "antd";
import './style.scss';
import { fetchAssets } from "../../../actions/mine_craft/assetsActions";
import List from "../../mine_craft/Assets/_partials/_List";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import { InboxOutlined, SettingOutlined } from "@ant-design/icons";
import { setNewGroupParams, setReorderIds, selectAssetIds } from "../../../store/mine_craft/assetsSlice";
import Dropzone from "../../mine_craft/Assets/Dropzone";
import { queryParams } from "../../../helpers/UrlHelpers";
import { useSearchParams } from "react-router-dom";
import Filter, { FilterInterface } from "../../../componets/Filter";
import Settings from "./Settings";

export interface PropsInterface {
  appId: 1 | 2;
}
const LIMIT = 42;
const DEFAULT_ORDER_BY = 'order';

const Assets = ({ appId }: PropsInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const status = useAppSelector(state => state.mineCraft.assets.status);
  const error = useAppSelector(state => state.mineCraft.assets.error);
  const ids = useAppSelector(selectAssetIds);
  const target = queryParams.get(searchParams,'target');
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const filterProps: FilterInterface = {};

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT,
        target: target
      },
      ['order_by', 'order', 'date_from', 'date_to'],
      { 'order_by': DEFAULT_ORDER_BY }
    );

    dispatch(fetchAssets(params));
  }, [dispatch, appId, target, currentPage, searchParams]);

  function onClickGroupCreate() {
    const params: any = { app_id: appId };

    dispatch(setNewGroupParams(params));
  }

  function onSettings() {
    dispatch(setReorderIds({ ids }));
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  filterProps.orderBy = {
    defaultKey: DEFAULT_ORDER_BY,
    defaultSort: 'asc',
    items: [
      { name: 'Date', key: 'id' },
    ]
  };

  function renderSettingButton() {
    return (
      <NavBarThree>
        <NavBarThree.Button onClick={onSettings}>
          <SettingOutlined /> Avatar Settings
        </NavBarThree.Button>
      </NavBarThree>
    );
  }

  return (
    <PageLayout>
      <PageHeader
        title='Avatars'
        align='right'
      >
        {renderSettingButton()}
      </PageHeader>

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickGroupCreate}>
            <InboxOutlined /> Avatar Dropzone
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            {...filterProps}
          />
        </Wrapper>

        <List limit={LIMIT} pagination={true} />
      </div>

      <Dropzone />
      <Settings />
    </PageLayout>
  );
}

export default Assets;
